export function formatValue(value: number) {
    if (value < 10_000) {
        return value.toString()
    }
    return value.toString().replace(/(\d)(?=(\d{3})+$)/g, '$1 ')
}
